var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

var purpleFillClasses = ['fill-black', 'fill-near-black', 'fill-dark-gray', 'fill-mid-gray', 'fill-gray', 'fill-silver ', 'fill-light-silver', 'fill-lightest-silver', 'fill-moon-gray', 'fill-light-gray', 'fill-near-white', 'fill-white', 'fill-transparent', 'fill-dark-red', 'fill-red', 'fill-light-red', 'fill-orange', 'fill-gold', 'fill-yellow', 'fill-light-yellow', 'fill-purple', 'fill-light-purple', 'fill-dark-pink', 'fill-hot-pink', 'fill-pink', 'fill-light-pink', 'fill-dark-green', 'fill-green', 'fill-light-green', 'fill-navy', 'fill-dark-blue', 'fill-blue', 'fill-light-blue', 'fill-lightest-blue', 'fill-washed-blue', 'fill-washed-green', 'fill-washed-yellow', 'fill-washed-red'];

var purpleGradientFillClasses = ['purple', 'dark-gray', 'red', 'orange', 'green', 'blue'];

var MalibuIcon = (_temp = _class = function (_React$Component) {
  _inherits(MalibuIcon, _React$Component);

  function MalibuIcon() {
    _classCallCheck(this, MalibuIcon);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  MalibuIcon.prototype.render = function render() {
    var _props = this.props,
        extraClasses = _props.extraClasses,
        fillClass = _props.fillClass,
        name = _props.name,
        size = _props.size;

    var style = void 0;
    if (size) {
      style = {
        width: size + 'px',
        height: size + 'px'
      };
    }

    var classNames = void 0;
    if (purpleGradientFillClasses.includes(fillClass)) {
      classNames = 'malibu-fill-gradient-' + fillClass;
    }
    if (purpleFillClasses.includes(fillClass)) {
      classNames = fillClass;
    }
    if (extraClasses) {
      classNames += ' ' + extraClasses;
    }

    return React.createElement(
      'svg',
      { style: style, className: classNames },
      React.createElement('use', { xlinkHref: '#' + name })
    );
  };

  return MalibuIcon;
}(React.Component), _class.defaultProps = {
  fillClass: 'purple'
}, _temp);
export { MalibuIcon as default };
MalibuIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  extraClasses: PropTypes.string,
  fillClass: PropTypes.oneOf(purpleGradientFillClasses.concat(purpleFillClasses)),
  name: PropTypes.string.isRequired,
  size: PropTypes.number
} : {};